export var ExpirationType;
(function (ExpirationType) {
    ExpirationType["UNKNOWN_EXPIRATION_TYPE"] = "UNKNOWN_EXPIRATION_TYPE";
    ExpirationType["NONE"] = "NONE";
    ExpirationType["FIXED"] = "FIXED";
    ExpirationType["RELATIVE"] = "RELATIVE";
})(ExpirationType || (ExpirationType = {}));
export var TimePeriod;
(function (TimePeriod) {
    TimePeriod["UNKNOWN_TIME_PERIOD"] = "UNKNOWN_TIME_PERIOD";
    TimePeriod["DAYS"] = "DAYS";
    TimePeriod["WEEKS"] = "WEEKS";
    TimePeriod["MONTHS"] = "MONTHS";
    TimePeriod["YEARS"] = "YEARS";
})(TimePeriod || (TimePeriod = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map